<template>
  <div class="share-alert-wrapper" v-show="showShareAlert" @click.stop.prevent="closeAlert">
    <div class="share-content">
      <img :src="guideImage">
    </div>
  </div>
</template>

<script>
import guideImg1 from '../images/yj_share_guide1.png'
import guideImg2 from '../images/yj_share_guide2.png'

export default {
  name: 'shareAlert',
  props: {
    showShareAlert: {
      type: Boolean,
      default: false
    },
    guideType: {
      type: Number,
      default: 1
    }
  },
  computed: {
    guideImage() {
      return this.guideType === 1 ? guideImg1 : guideImg2
    }
  },
  methods: {
    closeAlert() {
      this.$emit('update:showShareAlert', false)
    }
  }
}
</script>

<style lang="less" scoped>
.share-alert-wrapper {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 999;
  .share-content {
    margin-top: 0.6rem;
    width: 100%;
    img {
      display: block;
      width: 100%;
    }
  }
}
</style>
